import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { BaseResponse } from "../models/base.response";

@Injectable({
    providedIn: 'root'
})
export class QuestionsService {

    constructor(private http: HttpClient) {
    }

    find(testTypeId: number): Observable<BaseResponse<any>> {
        let params = new HttpParams().set('testTypeId', testTypeId);
        return this.http.get<BaseResponse<any>>(`${environment.apiUrl}/questions/search`, { params });
    }

}